module.exports = __webpack_public_path__ + "img/num4.f8bd4ff9.png";